import { ADD_NEW_USER } from "../constants/add-user";

type UserFormData = {
  firstName: string;
  lastName: string;
  gender: number;
  tel: string;
};
export function addNewUser(data: UserFormData) {
  return {
    type: ADD_NEW_USER,
    api: true,
    payload: {
      method: "POST",
      url: "/new_user",
      data,
    },
  };
}
